// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3fAul","tab":"Tabs_tab__1nBbk","tabActive":"Tabs_tabActive__4mXgm"};